// Instagram handle helpers shared by the signup wizard and Settings > Branding.
// Keep HANDLE_REGEX in sync with customBranding.instagramHandle in msb-api.
const HANDLE_REGEX = /^[A-Za-z0-9._]{1,30}$/;
const INSTAGRAM_URL_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?instagram\.com(?:\/|$)/i;

// Accepts "name", "@name" or a pasted profile URL and returns the bare handle.
// String() because castJSON turns an all-digit handle into a number.
export const normalizeInstagramHandle = (value) =>
  String(value ?? "")
    .trim()
    .replace(INSTAGRAM_URL_REGEX, "")
    .replace(/^@/, "")
    .split(/[/?#]/)[0];

export const isValidInstagramHandle = (handle) => HANDLE_REGEX.test(handle);

export const isInstagramUrl = (value) =>
  INSTAGRAM_URL_REGEX.test(String(value ?? "").trim());

export const instagramLinkFor = (handle) => `https://instagram.com/${handle}`;

// Handle from an existing profile link (coaches who set instagramLink before
// the handle field existed). Non-profile URLs (posts, reels, …) give "".
export const instagramHandleFromLink = (link) => {
  if (!isInstagramUrl(link)) return "";
  const path = String(link)
    .trim()
    .replace(INSTAGRAM_URL_REGEX, "")
    .split(/[?#]/)[0]
    .replace(/\/$/, "");
  return isValidInstagramHandle(path) ? path : "";
};
